import { render, staticRenderFns } from "./param-sfe.html?vue&type=template&id=8f8a423c&scoped=true&external"
import script from "./param-sfe.js?vue&type=script&lang=js&external"
export * from "./param-sfe.js?vue&type=script&lang=js&external"
import style0 from "./param-sfe.scss?vue&type=style&index=0&id=8f8a423c&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f8a423c",
  null
  
)

export default component.exports